import React, { useState, useEffect, useRef } from "react";
import ChatBot from "react-simple-chatbot";
import { ThemeProvider } from "styled-components";
import Lottie from "lottie-react";
import Cookies from "js-cookie";
import medneslon from "../../img/boot.json";

const WelcomeLottie = () => {
  const lottieRef = useRef();

  useEffect(() => {
    if (lottieRef.current) {
      lottieRef.current.setSpeed(0.3);
    }
  }, []);

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        padding: "10px 0",
      }}
    >
      <Lottie
        lottieRef={lottieRef}
        animationData={medneslon}
        loop={true}
        style={{ height: 120 }}
      />
    </div>
  );
};

const RequestHandler = ({ steps, triggerNextStep }) => {
  const [loading, setLoading] = useState(true);
  const [answer, setAnswer] = useState("");

  useEffect(() => {
    const queryBackend = async () => {
      const userMessage = steps.user_input.value;

      try {
        const response = await fetch(
          "https://helpdesk.medsystems.com.br/api/portalCliente/chat",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + Cookies.get("bearer"),
            },
            body: JSON.stringify({
              messages: [
                { author: "user", type: "text", data: { text: userMessage } },
              ],
              username: localStorage.getItem("username"),
            }),
          },
        );

        const data = await response.json();
        setAnswer(data.message.content);
        setLoading(false);
        triggerNextStep({ trigger: "user_input" });
      } catch (error) {
        setAnswer("Ops, tive um problema na conexão.");
        setLoading(false);
        triggerNextStep({ trigger: "user_input" });
      }
    };

    queryBackend();
  }, []);

  if (loading) return <div>Digitando...</div>;
  return <div>{answer}</div>;
};

const MyChatBot = () => {
  const theme = {
    background: "#f5f8fb",
    headerBgColor: "#004a8e",
    headerFontColor: "#fff",
    headerFontSize: "15px",
    botBubbleColor: "#004a8e",
    botFontColor: "#fff",
    userBubbleColor: "#fff",
    userFontColor: "#4a4a4a",
  };

  const steps = [
    {
      id: "1",
      component: <WelcomeLottie />,
      trigger: "welcome_text",
    },
    {
      id: "welcome_text",
      message: "Olá! Sou a MedAI, como posso ajudar hoje?",
      trigger: "user_input",
    },
    {
      id: "user_input",
      user: true,
      trigger: "api_response",
    },
    {
      id: "api_response",
      component: <RequestHandler />,
      waitAction: true,
      asMessage: true,
    },
  ];

  return (
    <ThemeProvider theme={theme}>
      <ChatBot
        steps={steps}
        floating={true}
        headerTitle="MedAI"
        placeholder="Digite sua mensagem..."
        botAvatar="/portal/medAI.png"
      />
    </ThemeProvider>
  );
};

export default MyChatBot;
